/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedUsuariosRouteImport } from './routes/_authenticated/usuarios'
import { Route as AuthenticatedRetirosRouteImport } from './routes/_authenticated/retiros'
import { Route as AuthenticatedNotificacionesRouteImport } from './routes/_authenticated/notificaciones'
import { Route as AuthenticatedMetricasRouteImport } from './routes/_authenticated/metricas'
import { Route as AuthenticatedMensajesRouteImport } from './routes/_authenticated/mensajes'
import { Route as AuthenticatedEventosRouteImport } from './routes/_authenticated/eventos'
import { Route as AuthenticatedCuponesRouteImport } from './routes/_authenticated/cupones'
import { Route as AuthenticatedCuentasRouteImport } from './routes/_authenticated/cuentas'
import { Route as AuthenticatedClientesRouteImport } from './routes/_authenticated/clientes'
import { Route as AuthenticatedChatsRouteImport } from './routes/_authenticated/chats'
import { Route as AuthenticatedBonosRouteImport } from './routes/_authenticated/bonos'
import { Route as AuthenticatedAuditoriaRouteImport } from './routes/_authenticated/auditoria'
import { Route as AuthenticatedApisRouteImport } from './routes/_authenticated/apis'
import { Route as AuthenticatedAjustesRouteImport } from './routes/_authenticated/ajustes'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsuariosRoute = AuthenticatedUsuariosRouteImport.update({
  id: '/usuarios',
  path: '/usuarios',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRetirosRoute = AuthenticatedRetirosRouteImport.update({
  id: '/retiros',
  path: '/retiros',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotificacionesRoute =
  AuthenticatedNotificacionesRouteImport.update({
    id: '/notificaciones',
    path: '/notificaciones',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMetricasRoute = AuthenticatedMetricasRouteImport.update({
  id: '/metricas',
  path: '/metricas',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMensajesRoute = AuthenticatedMensajesRouteImport.update({
  id: '/mensajes',
  path: '/mensajes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEventosRoute = AuthenticatedEventosRouteImport.update({
  id: '/eventos',
  path: '/eventos',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCuponesRoute = AuthenticatedCuponesRouteImport.update({
  id: '/cupones',
  path: '/cupones',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCuentasRoute = AuthenticatedCuentasRouteImport.update({
  id: '/cuentas',
  path: '/cuentas',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClientesRoute = AuthenticatedClientesRouteImport.update({
  id: '/clientes',
  path: '/clientes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChatsRoute = AuthenticatedChatsRouteImport.update({
  id: '/chats',
  path: '/chats',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBonosRoute = AuthenticatedBonosRouteImport.update({
  id: '/bonos',
  path: '/bonos',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAuditoriaRoute = AuthenticatedAuditoriaRouteImport.update({
  id: '/auditoria',
  path: '/auditoria',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedApisRoute = AuthenticatedApisRouteImport.update({
  id: '/apis',
  path: '/apis',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAjustesRoute = AuthenticatedAjustesRouteImport.update({
  id: '/ajustes',
  path: '/ajustes',
  getParentRoute: () => AuthenticatedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/ajustes': typeof AuthenticatedAjustesRoute
  '/apis': typeof AuthenticatedApisRoute
  '/auditoria': typeof AuthenticatedAuditoriaRoute
  '/bonos': typeof AuthenticatedBonosRoute
  '/chats': typeof AuthenticatedChatsRoute
  '/clientes': typeof AuthenticatedClientesRoute
  '/cuentas': typeof AuthenticatedCuentasRoute
  '/cupones': typeof AuthenticatedCuponesRoute
  '/eventos': typeof AuthenticatedEventosRoute
  '/mensajes': typeof AuthenticatedMensajesRoute
  '/metricas': typeof AuthenticatedMetricasRoute
  '/notificaciones': typeof AuthenticatedNotificacionesRoute
  '/retiros': typeof AuthenticatedRetirosRoute
  '/usuarios': typeof AuthenticatedUsuariosRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/ajustes': typeof AuthenticatedAjustesRoute
  '/apis': typeof AuthenticatedApisRoute
  '/auditoria': typeof AuthenticatedAuditoriaRoute
  '/bonos': typeof AuthenticatedBonosRoute
  '/chats': typeof AuthenticatedChatsRoute
  '/clientes': typeof AuthenticatedClientesRoute
  '/cuentas': typeof AuthenticatedCuentasRoute
  '/cupones': typeof AuthenticatedCuponesRoute
  '/eventos': typeof AuthenticatedEventosRoute
  '/mensajes': typeof AuthenticatedMensajesRoute
  '/metricas': typeof AuthenticatedMetricasRoute
  '/notificaciones': typeof AuthenticatedNotificacionesRoute
  '/retiros': typeof AuthenticatedRetirosRoute
  '/usuarios': typeof AuthenticatedUsuariosRoute
  '/': typeof AuthenticatedIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/ajustes': typeof AuthenticatedAjustesRoute
  '/_authenticated/apis': typeof AuthenticatedApisRoute
  '/_authenticated/auditoria': typeof AuthenticatedAuditoriaRoute
  '/_authenticated/bonos': typeof AuthenticatedBonosRoute
  '/_authenticated/chats': typeof AuthenticatedChatsRoute
  '/_authenticated/clientes': typeof AuthenticatedClientesRoute
  '/_authenticated/cuentas': typeof AuthenticatedCuentasRoute
  '/_authenticated/cupones': typeof AuthenticatedCuponesRoute
  '/_authenticated/eventos': typeof AuthenticatedEventosRoute
  '/_authenticated/mensajes': typeof AuthenticatedMensajesRoute
  '/_authenticated/metricas': typeof AuthenticatedMetricasRoute
  '/_authenticated/notificaciones': typeof AuthenticatedNotificacionesRoute
  '/_authenticated/retiros': typeof AuthenticatedRetirosRoute
  '/_authenticated/usuarios': typeof AuthenticatedUsuariosRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/ajustes'
    | '/apis'
    | '/auditoria'
    | '/bonos'
    | '/chats'
    | '/clientes'
    | '/cuentas'
    | '/cupones'
    | '/eventos'
    | '/mensajes'
    | '/metricas'
    | '/notificaciones'
    | '/retiros'
    | '/usuarios'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/ajustes'
    | '/apis'
    | '/auditoria'
    | '/bonos'
    | '/chats'
    | '/clientes'
    | '/cuentas'
    | '/cupones'
    | '/eventos'
    | '/mensajes'
    | '/metricas'
    | '/notificaciones'
    | '/retiros'
    | '/usuarios'
    | '/'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/ajustes'
    | '/_authenticated/apis'
    | '/_authenticated/auditoria'
    | '/_authenticated/bonos'
    | '/_authenticated/chats'
    | '/_authenticated/clientes'
    | '/_authenticated/cuentas'
    | '/_authenticated/cupones'
    | '/_authenticated/eventos'
    | '/_authenticated/mensajes'
    | '/_authenticated/metricas'
    | '/_authenticated/notificaciones'
    | '/_authenticated/retiros'
    | '/_authenticated/usuarios'
    | '/_authenticated/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/usuarios': {
      id: '/_authenticated/usuarios'
      path: '/usuarios'
      fullPath: '/usuarios'
      preLoaderRoute: typeof AuthenticatedUsuariosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/retiros': {
      id: '/_authenticated/retiros'
      path: '/retiros'
      fullPath: '/retiros'
      preLoaderRoute: typeof AuthenticatedRetirosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notificaciones': {
      id: '/_authenticated/notificaciones'
      path: '/notificaciones'
      fullPath: '/notificaciones'
      preLoaderRoute: typeof AuthenticatedNotificacionesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/metricas': {
      id: '/_authenticated/metricas'
      path: '/metricas'
      fullPath: '/metricas'
      preLoaderRoute: typeof AuthenticatedMetricasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mensajes': {
      id: '/_authenticated/mensajes'
      path: '/mensajes'
      fullPath: '/mensajes'
      preLoaderRoute: typeof AuthenticatedMensajesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/eventos': {
      id: '/_authenticated/eventos'
      path: '/eventos'
      fullPath: '/eventos'
      preLoaderRoute: typeof AuthenticatedEventosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/cupones': {
      id: '/_authenticated/cupones'
      path: '/cupones'
      fullPath: '/cupones'
      preLoaderRoute: typeof AuthenticatedCuponesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/cuentas': {
      id: '/_authenticated/cuentas'
      path: '/cuentas'
      fullPath: '/cuentas'
      preLoaderRoute: typeof AuthenticatedCuentasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clientes': {
      id: '/_authenticated/clientes'
      path: '/clientes'
      fullPath: '/clientes'
      preLoaderRoute: typeof AuthenticatedClientesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chats': {
      id: '/_authenticated/chats'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof AuthenticatedChatsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bonos': {
      id: '/_authenticated/bonos'
      path: '/bonos'
      fullPath: '/bonos'
      preLoaderRoute: typeof AuthenticatedBonosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/auditoria': {
      id: '/_authenticated/auditoria'
      path: '/auditoria'
      fullPath: '/auditoria'
      preLoaderRoute: typeof AuthenticatedAuditoriaRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/apis': {
      id: '/_authenticated/apis'
      path: '/apis'
      fullPath: '/apis'
      preLoaderRoute: typeof AuthenticatedApisRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ajustes': {
      id: '/_authenticated/ajustes'
      path: '/ajustes'
      fullPath: '/ajustes'
      preLoaderRoute: typeof AuthenticatedAjustesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAjustesRoute: typeof AuthenticatedAjustesRoute
  AuthenticatedApisRoute: typeof AuthenticatedApisRoute
  AuthenticatedAuditoriaRoute: typeof AuthenticatedAuditoriaRoute
  AuthenticatedBonosRoute: typeof AuthenticatedBonosRoute
  AuthenticatedChatsRoute: typeof AuthenticatedChatsRoute
  AuthenticatedClientesRoute: typeof AuthenticatedClientesRoute
  AuthenticatedCuentasRoute: typeof AuthenticatedCuentasRoute
  AuthenticatedCuponesRoute: typeof AuthenticatedCuponesRoute
  AuthenticatedEventosRoute: typeof AuthenticatedEventosRoute
  AuthenticatedMensajesRoute: typeof AuthenticatedMensajesRoute
  AuthenticatedMetricasRoute: typeof AuthenticatedMetricasRoute
  AuthenticatedNotificacionesRoute: typeof AuthenticatedNotificacionesRoute
  AuthenticatedRetirosRoute: typeof AuthenticatedRetirosRoute
  AuthenticatedUsuariosRoute: typeof AuthenticatedUsuariosRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAjustesRoute: AuthenticatedAjustesRoute,
  AuthenticatedApisRoute: AuthenticatedApisRoute,
  AuthenticatedAuditoriaRoute: AuthenticatedAuditoriaRoute,
  AuthenticatedBonosRoute: AuthenticatedBonosRoute,
  AuthenticatedChatsRoute: AuthenticatedChatsRoute,
  AuthenticatedClientesRoute: AuthenticatedClientesRoute,
  AuthenticatedCuentasRoute: AuthenticatedCuentasRoute,
  AuthenticatedCuponesRoute: AuthenticatedCuponesRoute,
  AuthenticatedEventosRoute: AuthenticatedEventosRoute,
  AuthenticatedMensajesRoute: AuthenticatedMensajesRoute,
  AuthenticatedMetricasRoute: AuthenticatedMetricasRoute,
  AuthenticatedNotificacionesRoute: AuthenticatedNotificacionesRoute,
  AuthenticatedRetirosRoute: AuthenticatedRetirosRoute,
  AuthenticatedUsuariosRoute: AuthenticatedUsuariosRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
